import React, {useState} from 'react'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import CreateCustomRate from '../ShippingRateList/CreateCustomRate'
import {useDispatch} from 'react-redux'
import {
  checkCompliance,
  setIsCustomShipping,
  setShippingPrice,
} from 'app/features/orders/redux/order/orderEditSlice'
import OrderModalButton from 'app/features/orders/componentsv1/view/orderModal/OrderModalButton'
import {Button} from '_core'

interface Props {
  onCloseCustomRate: () => void
  onClose?: any
}

export const CustomShipRateDialog: React.FC<Props> = ({onCloseCustomRate, onClose}) => {
  const dispatch = useDispatch()
  const [shippingPrice, _setShippingPrice] = useState<any>(0)

  const handleSetPrice = (rate: any) => {
    _setShippingPrice(rate)
    dispatch(checkCompliance())
  }

  const handleConfirm = () => {
    dispatch(setIsCustomShipping(true))
    dispatch(setShippingPrice(shippingPrice))
    onClose()
    onCloseCustomRate()
  }

  return (
    <OrderModal
      btnText='Confirm'
      title='Create Custom Shipping Rate'
      onClose={onCloseCustomRate}
      icon='delivery-van'
      hideFooter
      footer={
        <div className='card-footer mx-4'>
          <OrderModalButton onClose={onCloseCustomRate}>
            <Button
              id='btnPay'
              title='Confirm'
              className='btn btn-primary-active w-100'
              onClick={handleConfirm}
              disabled={!shippingPrice}
            />
          </OrderModalButton>
        </div>
      }
    >
      <CreateCustomRate onChangePrice={handleSetPrice} price={shippingPrice} />
    </OrderModal>
  )
}

export default CustomShipRateDialog
